export const environment = {
  production: true,
  sharedConfig: {
    applicationName: 'UserManager',
  },
  sentry: {
    dsn: 'https://e0d61d6ff47948cd760b4506697646fa@sentry.theidolops.com/77',
  },
};
